import { API } from 'aws-amplify';

////////////////////////////////////////////////////////////////////////////////////////////////////
// Sorting comparison functions

function compareSensorsBySerial( left, right ) {
    if ( left.serial < right.serial )
        return -1;

    if ( left.serial > right.serial )
        return 1;

    return 0;
}

function isNumber( x ) {
    return ! isNaN( parseFloat( x ) );
}

function leftFillNum( num, targetLength ) {
    return num.toString().padStart( targetLength, 0 );
}

// @args left : { name }, right : { name }
function compareSensorsByName( left, right ) {
    const split = function ( name ) {
        const parts = name.split( '-' );

        if ( parts.lenth < 1 )
            parts.push( '' );

        if ( isNumber( parts[0] ) )
            parts[0] = leftFillNum( parts[0], 4 );

        if ( isNumber( parts[1] ) )
            parts[1] = leftFillNum( parts[1], 4 );

        return parts;
    };

    const leftParts = split( left.name );
    const rightParts = split( right.name );

    // Compare first part 
    if ( leftParts[0] < rightParts[0] )
        return -1;

    if ( leftParts[0] > rightParts[0] )
        return 1;


    // First part equal, so compare second part

    if ( leftParts[1] < rightParts[1] )
        return -1;

    if ( leftParts[1] > rightParts[1] )
        return 1;

    // Second part equal, so just compare original strings
    if ( left < right )
        return -1;

    if ( left > right )
        return 1;

    return 0;
}

function compareSensorDayReadingByName( reading1, reading2 ) {
    // readings also have name fields
    return compareSensorsByName( reading1, reading2 );
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// Other

function peek( message ) {
    function stringify( object ) {
        var cache = [];

        const circularReplacer = ( key, value ) => {
            if ( typeof value === 'object' && value !== null ) {
                if ( cache.includes( value ) ) {
                    return '<circular reference>';
                }
                cache.push( value );
            }

            return value;
        };


        const result = JSON.stringify( object, circularReplacer, 2 );
        cache = null;

        return result;
    }

    return x => {
        console.log( message, typeof x );
        console.log( stringify( x ) );
        return x;
    };
}

function deduplicate( iterable, keyFunction ) {
    const seen = new Set();
    const createKey = keyFunction ? keyFunction : (x) => x;

    const isNotSeen = function ( item ) {
        const key = createKey( item );
        const notSeen = ! seen.has( key );

        seen.add( key);

        return notSeen;
    };

    return iterable.filter( isNotSeen );
}


function stringToColour( str ) {
    const hashCode = function(str) {
        return str.split('').reduce((prevHash, currVal) =>
                                    (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
    };

    var hash = hashCode( str );
    var colour = '#';
    for ( var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
    }

    return colour;
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// Account Ping


/**
 *
 * @param account: { apiKey, loginId, loginPassword }
 *
 * @return Promise of [ {
 *     num,
 *     serial,
 *     model,
 *     name,
 *     battery,
 *     channel : [ { num, name, value, unit } ],
 *     dst_bias,
 *     group,
 *     std_bias,
 *     time_diff,
 *     unixtime,
 * ]
 */
function pingAccount( cache, account ) {

    if ( ! account )
        return Promise.resolve( [] );

    if ( cache[ account.loginId ] )
        return Promise.resolve( cache[ account.loginId ] );

    const params = {
        apiKey : account.apiKey,
        loginId : account.loginId,
        loginPassword : account.loginPassword,
    };

    return API.get( 'tndaccountpingapi', '/ping', { queryStringParameters : params } ).then( response => {
        cache[ account.loginId ] = response.devices;

        const deviceDescriptions = response.devices.map( device => device.serial + ' (' + device.name + ')' );
        console.log( `Account ${account.description} (${account.loginId}) has ${deviceDescriptions.length} devices: `, deviceDescriptions );

        return cache[ account.loginId ];
    }, reason => {
        console.log( `Error pinging account ${account.loginId} (${account.location + '-' + account.description})`, reason );

        return [];
    } );
}

const dayjs = require( 'dayjs' );
const utcPlugin = require( 'dayjs/plugin/utc' );
const relativeTimePlugin = require( 'dayjs/plugin/relativeTime' );

require( 'dayjs/locale/es' );

dayjs.extend( utcPlugin );
dayjs.extend( relativeTimePlugin );
dayjs.locale( 'es' );


function dayjsFormatFullDate( dayjsValue ) {
    return dayjsValue.format( 'YYYY-MM-DD h:mm a' );
}

function dayjsFormatDate( dayjsValue ) {
    return dayjsValue.format( 'YYYY-MM-DD' );
}

function dayjsFormatTime( dayjsValue ) {
    return dayjsValue.format( 'h:mm a' );
}

function property( name ) {
    return x => x[ name ];
}

/**
 * device : { channel : [ { num } ] }
 */
function deviceNumberOfChannels( device ) {
    const maxChannel = device.channel.reduce( ( max, channel ) => Math.max( max, parseFloat( channel.num ) ), 1 );

    return maxChannel;
}

function deviceSensorName( sensorNameMap, device ) {
    const sensorName = sensorNameMap[ device.serial ],
          onlyCh1 = deviceNumberOfChannels( device ) < 2,
          newName = {
              serial : device.serial,
              name   : device.name,
              ch1    : onlyCh1 ? device.name : device.channel[0].name,
              ch2    : onlyCh1 ? null : deviceNameCh2( {} , device ) || '',
          };

    return sensorName || newName;
}

function deviceNameCh1( sensorNameMap, device ) {
    const serial = device.serial,
          hasChannel2 = deviceNumberOfChannels( device ) > 1,
          deviceName = hasChannel2 ? device.channel[0].name : device.name,
          name = sensorNameMap[ serial ],
          nameCh1 = name ? name.ch1 : null;

    return nameCh1 || deviceName;
}

function deviceNameCh2( sensorNameMap, device ) {
    const serial = device.serial,
          deviceName = device.channel.find( ch => ch.num === '2' ).name,
          name = sensorNameMap[ serial ],
          nameCh2 = name ? name.ch2 : null;

    return nameCh2 || deviceName;
}

export {
    compareSensorsBySerial,
    compareSensorsByName,
    compareSensorDayReadingByName,
    peek,
    deduplicate,
    stringToColour,
    pingAccount,
    dayjs,
    dayjsFormatFullDate,
    dayjsFormatDate,
    dayjsFormatTime,
    property,
    deviceNumberOfChannels,
    deviceSensorName,
    deviceNameCh1,
    deviceNameCh2,
};
